import { useState } from "react";
import { Button } from "flowbite-react";
import { ConversionDialog } from "@/features/purchasePoints/components/conversion/ConversionDialog";
import { PURCHASE_POINTS_CONVERT_CTA_LABEL } from "@/features/purchasePoints/config/purchasePoints.config";

type PurchasePointsConvertCtaProps = {
  availablePoints: number
  pointsPerEuro: number
};

/**
 * With nothing to convert there is no button at all, not a disabled one: a
 * refusal the employee cannot act on is noise.
 *
 * An open dialog keeps the component mounted even once the balance has reached
 * zero, otherwise a successful conversion would unmount its own confirmation
 * the moment the refreshed balance came back.
 */
export const PurchasePointsConvertCta = ({ availablePoints, pointsPerEuro }: PurchasePointsConvertCtaProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const hasPointsToConvert = availablePoints > 0;

  if (!isDialogOpen && !hasPointsToConvert) return null;

  return (
    <>
      {hasPointsToConvert && (
        <Button
          color="primary"
          className="mt-2"
          onClick={() => setIsDialogOpen(true)}
          data-testid="purchase-points-convert"
        >
          {PURCHASE_POINTS_CONVERT_CTA_LABEL}
        </Button>
      )}

      <ConversionDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        availablePoints={availablePoints}
        pointsPerEuro={pointsPerEuro}
      />
    </>
  );
};

PurchasePointsConvertCta.displayName = "PurchasePointsConvertCta";
